import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

document.addEventListener("DOMContentLoaded", () => {
  const inlineEl = document.getElementById("ganjier-calendar");
  if(inlineEl) {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      inlineEl
    );
  }

  const inputs : NodeListOf<HTMLInputElement> = document.querySelectorAll("input[data-ganjier-calendar]");
  inputs.forEach((el) => {
    const div = document.createElement('div');
    el.parentElement?.append(div)
    div.append(el);
    const reactDiv = document.createElement('div');
    div.append(reactDiv);

    el.type = 'text';
    el.onkeydown = () => false;

    const type = (el.getAttribute('data-ganjier-calendar') ?? undefined) as 'live_event'|'exam'|undefined;
    ReactDOM.render(
      <React.StrictMode>
        <div style={{position: "relative"}}>
          <App inputEl={el} type={type}/>
        </div>
      </React.StrictMode>,
      reactDiv
    );
  });
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
